import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PagelaService {

  public events: any[] = [];
  public loadingGrades = new BehaviorSubject<boolean>(false);
  
  constructor(private http: HttpClient) {}

  /*
   * Recebe todos os dados os horários de aula por data selecionada
   */
  public getClassesByDate(startDate: string, endDate: string): any {
    let params = new HttpParams()
                    .set('startDate', startDate)
                    .set('endDate', endDate)
        
    return this.http.get(`${environment.api}/teachers/classes`, { params }).toPromise().then((data: any) => data.data.events);
  }

  /**
   * Descricao: Recebe os alunos do mapa selecionado
   * @param idTeacher 
   * @param selectDay 
   * @param email 
   * @param idNivel 
   * @param idMapa 
   */
  public getPagelaClass(classeId: number, date: string): Observable<any> {     
    let params = new HttpParams().set('date', date);                     
                     
    return this.http.get<any>(`${environment.api}/teachers/classes/${classeId}`, { params }).pipe(      
      map((classe: any) => classe),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Obtem os dados da pagela em modo leitura
   * @param idTeacher 
   * @param selectDay 
   * @param email 
   * @param idNivel 
   * @param idMapa 
   * @param horario 
   */
  public getPagelaLeitura(idTeacher: number, selectDay: string, email: string, idNivel: number, idMapa: number, horario: string): Observable<any> {
    const params = new HttpParams()
                    .set('idTeacher', idTeacher.toString())
                    .set('selectDay', selectDay)
                    .set('idNivel', idNivel.toString())
                    .set('idMapa', idMapa.toString())
                    .set('horario', horario.toString())
                    .set('email', email);

    return this.http.get<any>(`${environment.api}/pagela/leitura`, { params }).pipe(
      take(1),
      map((pagela: any) => pagela),
      catchError(this.handleError)
    );
  }

  /**
   * description: Salva a lista de presença dos alunos
   * @param data 
   */
  public savePagela(data: any): Observable<any> {  
    return this.http.patch<any>(`${environment.api}/teachers/classes`, data).pipe(
      map((pagela: any) => pagela),
      catchError(this.handleError)
    );
  }
  
  /**
   * description: Retorna o panorama da turma selecionada
   * @param idMapa 
   * @param email 
   */
  public getPanorama(idMapa: number): Observable<any> {
    let params = new HttpParams()
                    .set('idMapa', idMapa.toString())

    return this.http.get<any>(`${environment.api}/teachers/pagelas/panoramas`, { params }).pipe(
      map((panorama: any) => panorama),
      catchError(this.handleError)
    );
  }

  /**
   * description: retorna as notas fragmentadas do panorama
   * @param idGrade 
   * @param email 
   * @param label 
   * @param idNivel
   * @param semestre
   */
  public getPanoramaOralGrade(idGrade: number, label: string, idNivel: number, semestre: string): Observable<any> {
    
    this.loadingGrades.next(true);

    let params = new HttpParams()                           
                    .set('idGrade', idGrade.toString())
                    .set('label', label)
                    .set('idNivel', idNivel.toString())
                    .set('semestre', semestre.toString())                        

    return this.http.get<any>(`${environment.api}/teachers/pagelas/grades/oralgrade`, { params }).pipe(
      take(1),
      map((grades: any) => {
        this.loadingGrades.next(false);
        return grades;
      }),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Retorna os dados completo do aluno
   * @param idAluno 
   * @param email 
   * @param idTipoAcesso 
   */
  public getDataCompleteStudent(idAluno: number): Observable<any> {
    let params = new HttpParams()                           
                    .set('idAluno', idAluno.toString())

    return this.http.get<any>(`${environment.api}/teachers/pagelas/students`, { params }).pipe(
      map((notes: any) => notes),
      catchError(this.handleError)
    );
  }

   /**
   * description: Salva as notas do aluno
   * @param data 
   */
  public saveGrades(data: any): Observable<string> {  
    return this.http.put<string>(`${environment.api}/teachers/pagelas/grades`, data).pipe(
      map((result: any) => result.message),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Salva o conteudo dos campos aulas ministras e homeworking
   * @param data 
   */
  public updateTxtAulasMinistradas(data: any): Observable<string> {
    console.log(data);
    return this.http.patch<string>(`${environment.api}/teachers/classes/notes`, data).pipe(
      map((result: any) => result.message),
      catchError(this.handleError)
    );
  }  
  
  /**
   * Description: Envia os dados para solicitação de edição pagela
   * @param data 
   */
  public solicitacaoEdicaoPagela(data: any): Observable<string> {    
    return this.http.post<any>(`${environment.api}/teachers/classes/releases`, data).pipe(
      map((result: any) => result.message),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Retorna todos os periodos
   * @param email 
   */
  public getAllPeriodosParametro(): Observable<any[]> {    
    return this.http.get<any[]>(`${environment.api}/teachers/searchs/periodos`).pipe(
      map((result: any) => result),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Retorna todos os professores por ano/periodo
   * @param email 
   * @param ano 
   */
  public getAllProfessorByYear(ano: number, idProfessor: number): Observable<any[]> {
    const params = new HttpParams()                                     
                    .set('ano', ano.toString())
                    .set('idProfessor', idProfessor.toString())

    return this.http.get<any[]>(`${environment.api}/teachers`, { params }).pipe(      
      map((result: any) => result),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Retorna todas as turmas do professor
   * @param email 
   * @param ano 
   * @param semestre 
   * @param idProfessor 
   */
  public getAllTurmasByTeacher( ano: number, semestre: number, idProfessor: number): Observable<any[]> {
    const params = new HttpParams()                            
                      .set('idProfessor', idProfessor.toString())
                      .set('semestre', semestre.toString())                                       
                      .set('ano', ano.toString())
                    
    return this.http.get<any[]>(`${environment.api}/teachers/searchs/classes`, { params }).pipe(
      map((result: any) => result),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Set os dados para Liberar a pagela
   * @param parameters 
   */
  public liberaPagela(data: any): Observable<any> {
    return this.http.post<any>(`${environment.api}/teachers/liberacoes`, data).pipe(
      map((result: any) => result.message),
      catchError(this.handleError)
    );
  }

  /**
   * Description: Recebe um list array com todas as pendência do professor para liberação
   * @param parameters 
   */
  public getAllLiberacoesByTeacher(parameters: any): Observable<Array<any>> {
    const params = new HttpParams()                              
                      .set('idProfessor', parameters.idProfessor.toString())
                      .set('semestre', parameters.semestre.toString())                                       
                      .set('ano', parameters.ano.toString())

    return this.http.get<Array<any>>(`${environment.api}/teachers/liberacoes`, { params }).pipe(
      map((result: any) => result),
      catchError(this.handleError)
    );
  }
 
  // METHODS PRIVATES
  private jsonDataToPagela(jsonData: any): any[] {
    const pagelas: any[] = [];    
    jsonData.data.forEach(element => pagelas.push(element as any));
    return pagelas;
  }

  private handleError(error: any): Observable<any> {
    //console.log("ERRO NA REQUISIÇÃO =>", error);
    return throwError(error);
  }


}
